import React from 'react'
import Lottie from 'react-lottie'

import * as animationData from './../MainBlock/animate.json'

const Sphere = ({ isPlay }) => {
  const defaultOptions = {
    loop: true,
    autoplay: isPlay,
    animationData: animationData,
    duration: 1000,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div>
      <Lottie options={defaultOptions} height={300} width={300} speed={0.8} />
    </div>
  )
}

export default Sphere
